import $ from 'jquery';
export default function (instance) {
    const { config } = instance;
    const { id, position } = config;
    const circlePortDom = $(document.createElement('div')).attr({ id, class: 'oflow--node--circle-port' }).css({
        background: '#fff',
        width: 6,
        height: 6,
        border: '1px solid #c8c8c8',
        borderRadius: '50%',
        position: 'absolute',
        bottom: '-2px'
    })[0];
    const expandAreaMarginTop = ['top'].includes(position) ? -5 : ['bottom'].includes(position) ? 5 : 0;
    const expandAreaMarginLeft = ['left'].includes(position) ? -5 : ['right'].includes(position) ? 5 : 0;
    return $(document.createElement('div')).attr({
        class: 'oflow--node--circle-port--expand-area',
    }).css({
        width: 24,
        height: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '12px 12px 0 0',
        transform: position === 'bottom' ?
            'rotate(180deg)' : position === 'left' ?
            'rotate(-90deg)' : position === 'right' ?
            'rotate(90deg)' : 'unset',
        marginLeft: expandAreaMarginLeft,
        marginTop: expandAreaMarginTop,
        // background: extpandAreaColor,
    }).append(circlePortDom)[0];
}
//# sourceMappingURL=index.js.map